import { useState } from "react";
import { submitReflection } from "../../services/sessionService";
import "../../css2/ReflectionScreen.css";

const EMOJIS = [
  { icon: "😄", label: "Great" },
  { icon: "😊", label: "Good" },
  { icon: "🙂", label: "Okay" },
  { icon: "😐", label: "Meh" },
  { icon: "☹️", label: "Not really" },
];

// Generalised reflection screen — works for both capsule and library flows.
// Calls sessionService.completeSession and advances to CompletionScreen via onSubmit.

export default function ReflectionScreen({ sessionId, onClose, onSubmit }) {
  const [note, setNote] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedEmoji, setSelectedEmoji] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (submitting) return;
    setSubmitting(true);
    const feeling = selectedEmoji !== null ? selectedEmoji.label : "";
    try {
      await submitReflection({ sessionId, feeling, note: note.trim() });
    } catch (err) {
      console.error("Failed to submit reflection:", err);
    }
    onSubmit();
  };

  return (
    <div className="reflection-screen">
      <button
        className="reflection-screen__close"
        onClick={onClose}
        aria-label="Close"
      >
        ✕
      </button>

      <div className="reflection-screen__inner">
        <div className="reflection-screen__heading">
          <h1>How are you feeling now?</h1>
          <p>Take a moment to reflect on what you noticed during this exercise.</p>
        </div>

        <div className="reflection-screen__emojis">
          {EMOJIS.map((emoji) => (
            <button
              key={emoji.icon}
              onClick={() => setSelectedEmoji(emoji)}
              className={`reflection-screen__emoji-btn${
                selectedEmoji?.icon === emoji.icon
                  ? " reflection-screen__emoji-btn--selected"
                  : ""
              }`}
              aria-label={emoji.label}
            >
              {emoji.icon}
            </button>
          ))}
        </div>

        <div className="reflection-screen__note-area">
          {!isExpanded ? (
            <button
              className="reflection-screen__note-prompt"
              onClick={() => setIsExpanded(true)}
            >
              <span className="reflection-screen__note-icon">💭</span>
              <span>Tap to share your thoughts...</span>
            </button>
          ) : (
            <div className="reflection-screen__note-expanded">
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value.slice(0, 250))}
                placeholder="How are you feeling right now? What did you notice?"
                autoFocus
              />
              <span className="reflection-screen__char-count">
                {note.length}/250
              </span>
            </div>
          )}
        </div>

        <button
          className="reflection-screen__submit"
          onClick={handleSubmit}
          disabled={submitting}
        >
          {submitting ? "Saving..." : "Save & Continue"}
        </button>
      </div>
    </div>
  );
}
